export default () =>
  ['development', 'test', 'feqa-1', 'feqa-2', 'demo', 'stage'].includes(
    import.meta.env.VITE_ENV,
  );
